import { ModalWindow, BannerTypes } from './../constants/actionType';
import * as saveAction from './save';
import { updateSCTags, updateSCcustomEvent, tempSCData, comparePlanOverlayView, channelLineupOverlayView, whatToExpectOnNextBillOverlayView, termsOfServiceOverlayView, estimatedChargesOverlayView } from './../service/dtmTag';
import { updateVzdlSCCustomEvent, tempVzdlSCData , getIsVZFwdFlag} from './../service/vzdl';
import { InHomeUtils } from '../util/change/inhomeUtils';
import { populateVZDLoverlayName, updatecartEvent } from './../service/change/vzdl';
import { updateSCTagsmodalWindow } from './../service/change/dtmTag';

export const openModalWindow = (modalId, dispatch, isDoFlow, flowType = '', pegaState = '', bannerType = null, productid = null) => {
    if (modalId === "COUPON") {
        updateSCTags("special offer - redeem code");
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| special offer code redeem";
        updateSCcustomEvent("vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
        tempVzdlSCData.detail = "special offer code redeem";
        tempVzdlSCData.events = "prodView";
        updateVzdlSCCustomEvent("vzcRedeemLoad", "pageViewOmni", "detail");
    }
    //We now offer 2 ways to watch.
    if(modalId === "CEVROOM")
    {
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| tv| connections| set-top box ovrly";
        if (flowType !== undefined && flowType === "MV") {
            tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
        }
        updateSCcustomEvent("vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
        tempVzdlSCData.detail = "connections set-top box ovrly";
        tempVzdlSCData.events = "prodView";
        updateVzdlSCCustomEvent("vzcRedeemLoad", "pageViewOmni", "detail");
    }   
   //Do you have compatible device to stream FiosTV -overlay
    if(modalId === "CECEAPPSCONFIRM"){
        tempSCData.pageName = isDoFlow ? "do accord" : "byob"
        tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + "| tv| choose set-top box| compatible device";
        if (flowType !== undefined && flowType === "MV") {
            tempSCData.contentChannel = "/vz/residential/order/prospect accord move/select";
        }
        updateSCcustomEvent("vzcRedeemLoad", "ddAddToCartEvent", "detailPageName,pageName");
        tempVzdlSCData.detail = "choose set-top box compatible device";
        tempVzdlSCData.events = "prodView";
        updateVzdlSCCustomEvent("vzcRedeemLoad", "pageViewOmni", "detail");
    }


    if (modalId === 'HELPCUSTOMTV') {
        dispatch({ type: 'UPDATE_PREFERRED_RECOMMENDED_TV', value: '' });
    }
    dispatch({ type: ModalWindow.onModalWindowOpen, value: modalId })
    if (modalId === 'BANNER' && InHomeUtils.isNotNull(bannerType)) {
        const holidaySC = (bannerType === BannerTypes.HolidayOfferBAU || bannerType === BannerTypes.HolidayOfferBAUOld) ? '| holiday bnr ovrly| echo' : (bannerType === BannerTypes.HolidayOfferSOC || bannerType === BannerTypes.HolidayOfferNOC || bannerType === BannerTypes.HolidayOfferSOCOld || bannerType === BannerTypes.HolidayOfferNOCOld) ? '| holiday bnr ovrly| echo hulu' : '';
        if (holidaySC) {
            tempSCData.pageName = isDoFlow ? "do accord" : "byob"
            tempSCData.detailPageName = (isDoFlow ? "do accord" : "byob") + holidaySC;
            tempSCData.flowName = "prospect accord | mix match";
            updateSCcustomEvent("holidayOfferOverlay", "ddAddToCartEvent", "detailPageName,pageName")
        }
    }
    if (modalId === "COMPAREPRICE") {
        tempVzdlSCData.detail = flowType === "MV" ? "Compare Plans" : "Compare Price";
        tempVzdlSCData.events = "prodView";
        updateVzdlSCCustomEvent( flowType === "MV" ? "movesInterOrderSum":"vzcRedeemLoad", "pageViewOmni", "detail");
    }
    // if(modalId === "FAQ"){
    //     updateVzdlSCCustomEvent("faq", "pageViewOmni", "");
    // }
    if((modalId === 'FLASHOFFER_R1064') || (modalId ===  'FLASHOFFER_R1065')) {
        let blackFridaySC = (modalId === 'FLASHOFFER_R1064') ? "| internet| black friday| google nest ovrly" : "| internet| black friday| dlr200 gift ovrly" ;
        if(InHomeUtils.isNotNull(blackFridaySC)) {
            tempSCData.pageName =  isDoFlow ? "do accord" : "byob"
             tempSCData.detailPageName = ( isDoFlow ? "do accord" : "byob") + blackFridaySC;
             tempSCData.flowName = "prospect accord | mix match";
             updateSCcustomEvent("blackfridayOfferOverlay", "ddAddToCartEvent", "detailPageName,pageName")
             tempVzdlSCData.detail = (modalId === 'FLASHOFFER_R1064') ? "google nest ovrly" : "dlr200 gift ovrly";
             tempVzdlSCData.events = "prodView";
             updateVzdlSCCustomEvent("blackfridayOfferOverlay","pageViewOmni", "detail");
        }
     }

    if(modalId === 'AUTOPAYVZCCMODAL'){
        tempVzdlSCData.detail = "continue without discount";
        updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
    }
    if (flowType == 'urc') {
        updateSCClick(modalId, 'open', pegaState);
    }
    if (isDoFlow == "urc") {
        populateVZDLoverlayName(modalId);
        updatecartEvent("pageViewOmni");
        if (modalId === "COUPON")
            updateSCTagsmodalWindow("special offer - redeem code");
        else if (modalId === "compareplans")
            updateSCTagsmodalWindow("compare plan");
        else if (modalId === "channellineup" || modalId === "channelLineUp")
            updateSCTagsmodalWindow("channel lineup");
        else if (modalId === "fbe" || modalId === "FBE")
            updateSCTagsmodalWindow("estimate bill with charges");
        else if (modalId === "tos" || modalId === "TOS")
            updateSCTagsmodalWindow("terms of service");
        else if (modalId === "nextBill")
            updateSCTagsmodalWindow("what to expect on next bill");            
        else
            updateSCTagsmodalWindow(modalId);
    }
    if(isDoFlow == "MNHMODEL"){
        dispatch({ type: 'CART_MODAL_ISOC', value: productid })
    }
    if(window.chatWindowInBackGround){
        setTimeout(() => {
            window.chatWindowInBackGround(true);
        }, 100);
    }
};

export const closeModalWindow = (modalId, dispatch, actionType = '', triggerLinkCall = true, agreeLinkCall = false, enableACT112Sprint94Stories = 'N') => {
    console.log('======================== CHECK CHECK1 Source/src/action/modalWindow.js closeModalWindow ====================', { modalId, dispatch, actionType, triggerLinkCall, agreeLinkCall })
    dispatch({ type: ModalWindow.onModalWindowClose, value: modalId })
    if(actionType === 'MNHMODEL'){
        dispatch({ type: 'CART_MODAL_ISOC', value: '' })
    }
    else if (modalId === "COUPON") {
        updateSCTags("special offer - cancel");
    }
    else if (modalId === "CETVCONNECTIONS") {
        updateSCTags("got it set-top box");
    }
    else if (modalId ==="CECEAPPS"){
        updateSCTags("got it-stream fios tv");
    }
    //Smartcart changes for EC flow
    else if (modalId === "SAVE_EC") {
        saveAction.saveInvoked(false, dispatch);
    }
    else if (modalId === "SAVE" || modalId === "SAVE_MOBILE") {
        saveAction.backInvoked(false, dispatch);
        saveAction.saveInvoked(false, dispatch);
        saveAction.emailError(false, dispatch);
        saveAction.validateInput(false, dispatch);
    }
    else if (modalId === 'HELPCUSTOMTV') {
        dispatch({ type: 'CLEAR_QUESTIONS', value: [] })
    }
    else if(modalId === "WHW_ROUTERBILLER"){
        updateSCTags("close whole-home wi-fi(verizon router included) overlay");
    }
    else if(modalId === "WHWPlus_ROUTERBILLER"){
        updateSCTags("close whole-home wi-fi plus(verizon router included) overlay");
    }
    // Changes for PR00032100  HBO Only
    else if (modalId === 'unSupportedDetails') {
        let hboUnSupportedNotificationInfo = {
            //addChannel: '',
            showNotification: false
        }
        dispatch({ type: 'HBOUNSUPPORTED_NOTIFICATION', value: hboUnSupportedNotificationInfo });
    }
    else if(modalId === "SUBPROD_R1652"){
        updateSCTags("close 1 gig - streaming overlay");
    }
    else if(modalId === "SUBPROD_R1653"){
        updateSCTags("close 1 gig - gaming overlay");
    }
    else if(modalId === "SUBPROD_R1654"){
        updateSCTags("close 1 gig - complete overlay");
    }
    else if(modalId === "SUBPROD_R1649"){
        updateSCTags("close 2 gig - streaming overlay");
    }
    else if(modalId === "SUBPROD_R1650"){
        updateSCTags("close 2 gig - gaming overlay");
    }
    else if(modalId === "SUBPROD_R1651"){
        updateSCTags("close 2 gig - complete overlay");
    }
    else if(modalId === "PROMO"){
        updateSCTags("close offer-pricing-service details");
    }
    else if(triggerLinkCall && modalId === 'ADDITIONAL_SAVINGS'){
        updateSCTags('close m+h plan details overlay');
    }
    else if(triggerLinkCall && (modalId === 'mnhSignIn' || modalId ==='mnhBasicPhoneOverlay' || modalId === 'mnhPushNotificationOverlay' )){
        updateSCTags('close');
        dispatch({type: 'MNH_IG_VERIFICATION_START', value: false });
    }
    else if(modalId === "SM_EXISTINGCART"){
        updateSCTags("close cart");
    }
    else if(modalId === "SUPPBANNER"){
        updateSCTags("close current order");
    }
    else if(modalId === "HELPDATA"){
        updateSCTags("close");
    }
    else if(modalId === "INTLCALLINGOVERLAY"){
        updateSCTags("close intlcalling overlay");
    }
    else if(modalId === "HELPBATTERY"){
        updateSCTags("close help battery overlay");
    }
    else if (modalId === 'compareplans') {
        updateSCTags('close: compare plan');
    }
    else if (modalId === 'FBE') {
        updateSCTags('close: estimated charges');
    }
    else if (modalId === 'TOS') {
        if(agreeLinkCall){
            updateSCTags('agree');
        }
        else{
            updateSCTags('close');
        }
    }
    else if (modalId === 'SEEALLCHANNELSDETAILS') {
        updateSCTags('close: channel usage overlay');
    }
    else if (modalId === 'WHATSNEXTDETAILS') {
        updateSCTags('close: whats next overlay');
    }
    else if(modalId === "channelLineUp"){
        updateSCTags('close: channel line up');
    }
    else if(modalId === 'URCPerksOverlay'){
        if(enableACT112Sprint94Stories === 'Y') {
            updateSCTags('close button', '', "Zero Perk Upsell Modal - Netflix and Max (with ads)");
        }
        else {
            updateSCTags('close | modal');
        }
        dispatch({ type: "UPDATE_PERK_OVERLAY_VALUE", value: 'opened' });
    }
    else if(actionType === 'linkCall'){
        updateSCTags( getIsVZFwdFlag() ? "close | vfwd" : "close sign");
    }
    //changes to be added before updateSCClick
    if(actionType == "gotIt")
        updateSCTagsmodalWindow("got it");
      
    if(window.chatWindowInBackGround){
        window.chatWindowInBackGround(false);
    }
    console.log('=getIsVZFwdFlag==', getIsVZFwdFlag() )
};
export const closeCancelWindow = (modalId, dispatch) => {
    dispatch({ type: ModalWindow.onModalWindowClose, value: modalId })
    if (modalId === 'HELPCUSTOMTV') {
        dispatch({ type: 'UPDATE_RECOMMENDED_TV', value: '' })
        dispatch({ type: 'CLEAR_QUESTIONS', value: [] })
    }
};

export const updateSCClick = (id, action, pegaState = '') => {

    let value = '';
    if (action == 'open') {
        if (id == 'compareplans') {
            value = 'compare plan';
            if (InHomeUtils.isNotNull(pegaState))
                comparePlanOverlayView(pegaState);
        }
        else if (id == 'channelLineUp') {
            value = 'channel lineup';
            if (InHomeUtils.isNotNull(pegaState))
                channelLineupOverlayView(pegaState);
        }
        else if (id == 'FBE') {
            value = 'estimate bill with charges';
            if (InHomeUtils.isNotNull(pegaState))
                estimatedChargesOverlayView(pegaState);
        }
        else if (id == 'TOS') {
            value = '';
            if (InHomeUtils.isNotNull(pegaState))
                termsOfServiceOverlayView(pegaState);
        }
        else if (id == 'nextBill') {
            value = 'what on next bill';
            if (InHomeUtils.isNotNull(pegaState))
                whatToExpectOnNextBillOverlayView(pegaState);
        }
        else if (id == 'faq') {
            value = 'see faqs';
        }
        else if (id == 'WHATSNEXTDETAILS') {
            value = 'recmndtion ready: whats next';
        }
        else if (id == 'SEEALLCHANNELSDETAILS') {
            value = 'see all channels';
        }
        else if (id == 'storeLocator') {
            value = 'store locator';
        }
    }
    else if (action == 'close') {
        if (id == 'compareplans') {
            value = 'close: compare plan';
        }
        else if (id == 'FBE') {
            value = 'close: estimated charges';
        }
        else if (id == 'TOS') {
            value = 'close: tos';
        }
        else if (id == 'SEEALLCHANNELSDETAILS') {
            value = 'close: channel usage overlay';
        }
        else if (id == 'WHATSNEXTDETAILS') {
            value = 'close: whats next overlay';
        }
        else if(id == "channelLineUp"){
            value = 'close: channel line up';
        }
    }
    else {
        if (id)
            value = id;
    }
    if (value) {
        updateSCTags(value);
    }
}
